import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M20.236 2C19.478 2 18.786 2.428 18.447 3.106L18 4L2 4.001L3.001 10.091C3.001 10.57 3.341 10.982 3.812 11.073L15.996 13.5V14C15.996 14.552 15.548 15 14.996 15H4.001C3.449 15 3.001 15.448 3.001 16C3.001 16.552 3.449 17 4.001 17H15.2C16.746 17 18 15.746 18 14.2V14.198C18 14.066 18.013 13.935 18.039 13.806L19.868 4.659C19.945 4.276 20.281 4 20.672 4H22V2H20.236V2Z"
      fill="currentColor"
    />
    <path
      d="M9 20C9 21.105 8.105 22 7 22C5.895 22 5 21.105 5 20C5 18.895 5.895 18 7 18C8.105 18 9 18.895 9 20Z"
      fill="currentColor"
    />
    <path
      d="M17 20C17 21.105 16.105 22 15 22C13.895 22 13 21.105 13 20C13 18.895 13.895 18 15 18C16.105 18 17 18.895 17 20Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'CartFill');

export default Icon;
